function BottomNavigationFactory(container) {
  let BottomNavigation = class {
    constructor(container) {
      this.element = container;
      this.target = document.querySelector('[role="main"]');
      this.steps = this.element.querySelectorAll("[data-step]");
      this.setEvents();
    }

    onUnload() {
      this.carousel.destroy();
    }

    setEvents() {
      let hideBarWhenScrollDown = true;
      if (hideBarWhenScrollDown) {
        let lastScrollY = window.scrollY;
        let threshold = 50; // Threshold in pixels

        window.addEventListener("scroll", () => {
          const currentScrollY = window.scrollY;

          if (currentScrollY - lastScrollY > threshold) {
            // this.element.classList.add("inactive");
          } else if (lastScrollY - currentScrollY > 0) {
            // this.element.classList.remove("inactive");
          }

          lastScrollY = currentScrollY;
        });
      }

      setTimeout(() => {
        this.setInitialStep();
      }, 1000);
    }

    setInitialStep() {}
  };
  return new BottomNavigation(container);
}
